export class CommissionSalePromotion {
    public salePromotionId?:number;
    public description?:string;
    public promotionDateIni?:string;
    public promotionDateFin?:string;
    public saleAmountFrom?:number;
    public saleAmountTo?:number;
    public commission?:number;
    public additionalSchemaBase?:boolean;
    public digitalOrigin?:boolean;
    public unifielDigifiel?:boolean;
    public traditionalOrigin?:boolean;
    public minCreditAdv?:boolean;
    public minCreditAdvPerc?:number;
    public observations?:string;
    public onlyRefi?:boolean;
    public employeeJobs?:string;
    public businessProducts?:string;
    public financingTypes?:string;
    public afiliates?:string;
    public paymentTerms?:string;
    public financing?:string;
    public regions?:string;
    public states?:string;
    public createUserId?:number;
    public modifUserId?:number;
    public createDate?:string;
    public modifDate?:string;
    public activeId?:boolean;
}
